// extracted by mini-css-extract-plugin
export var dropdownButton = "_2w-0";
export var fullWidthDropdownButton = "_2w-1";
export var icon = "_2w-3";
export var iconPlaceholder = "_2w-2";
export var menuItemRow = "_2w-9";
export var separator = "_2w-e";
export var shortcutContainer = "_2w-7";
export var shortcutContainerFilled = "_2w-8";
export var shortcutIconLg = "_2w-6";
export var shortcutIconMd = "_2w-5";
export var shortcutIconSm = "_2w-4";
export var submenuChevron = "_2w-d";
export var submenuDropdown = "_2w-a";
export var submenuTriggerRow = "_2w-b";
export var submenuTriggerRowOpen = "_2w-c";